export default "__VITE_ASSET__P4va5Ek7__"